import { useTranslation } from 'react-i18next';
import { Skeleton, Tooltip } from '@mui/material';
import { VisibilityOutlined as PreviewIcon } from '@mui/icons-material';
import { useFlowBuilder2PageContext } from '../../Context/useFlowBuilder2PageContext';
import { StyledIconButton } from '../../FlowBuilder2Page.styles';
import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { FlowBuilder2PageViewNameEnum } from '../../Context/FlowBuilder2PageContext.types';

export const PreviewIconButton = () => {
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);
  const {
    isLoading: isLoadingPage,
    error: pageError,
    setActiveView,
  } = useFlowBuilder2PageContext();

  if (isLoadingPage) return <Skeleton variant="circular" width={32} height={32} />;
  if (!pageError)
    return (
      <Tooltip title={t('tooltips.preview')}>
        <StyledIconButton onClick={() => setActiveView(FlowBuilder2PageViewNameEnum.Preview)}>
          <PreviewIcon fontSize="small" />
        </StyledIconButton>
      </Tooltip>
    );

  return null;
};
